/**
 * Metric types for user marketing profile offers
 */
export enum UserMarketingProfileOfferMetricTypeEnum {
  // SENT_AT = "sentAt",
  PUO_VIEWED = "viewedAt", //for tracking specific PUO views
  CLICKED_AT = "clickedAt",
  CONVERTED_AT = "convertedAt",
  LINK_CLICKS = "linkClicks",
  WEBSITE_VISITS = "websiteVisits", //validated
  PAGES_VIEWED = "pagesViewed", //validated
  SESSION_LENGTH_SECONDS = "sessionLengthSeconds", //validated
  CONVERSIONS_TRACKED = "conversionsTracked",
  CONVERSION_VALUE_CENTS = "conversionValueCents",
  OFFER_SAVED = "offerSaved", //validated
}

/**
 * Descriptions for each metric type, explaining when they are emitted
 */
export const MetricDescriptions: Record<
  keyof typeof UserMarketingProfileOfferMetricTypeEnum,
  string
> = {
  PUO_VIEWED:
    "Emitted when a user lands on the offer page and the PUO Offer card is viewed",
  CLICKED_AT:
    "Emitted when a user clicks on a PUO, either via the BOOK NOW or Save For Later buttons",
  CONVERTED_AT:
    "Emitted when a user clicks the Book Now button, or the Attribution Identifying Button",
  LINK_CLICKS:
    "Emitted when a user clicks on a PUO, either via the BOOK NOW or Save For Later buttons",
  WEBSITE_VISITS:
    "Emitted when a user visits the website containing the offer.",
  PAGES_VIEWED:
    "Emitted when a user views a new page after landing on the offer page. This can show interest in the client's website.",
  SESSION_LENGTH_SECONDS:
    "Emitted like a heartbeat, every 60 seconds if the user has been active within the last 30 minutes",
  CONVERSIONS_TRACKED:
    "Emitted when the Book Now button is clicked, or when the Atttribution Identifying Button is clicked",
  CONVERSION_VALUE_CENTS:
    "Emitted when the Book Now button is clicked, or when the Attribution Identifying Button is clicked",
  OFFER_SAVED: "Emitted when a fills out the Save For Later form.",
};
